import { all, call, put, takeLatest, cancelled } from 'redux-saga/effects';
import {
  REIUMBURSEMENT_TABS_DATA_REQUEST,
  REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_REQUEST,
  REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_REQUEST,
  REIUMBURSEMENT_TABS_NONPAYMENT_REQUEST,
} from '@src/middleware/actions/actionTypes';
import {
  getReiumbursementTabData,
  getReiumbursementTabDataMetrics,
  getReiumbursementAppealsTabData,
  getReiumbursementReconsiderationTabData,
  getReiumbursementTabsDataDopFilters,
  getReiumbursementNonPaymentTabData,
} from '@src/middleware/services/reimbusement/reimbursementTabs/reiumbursementTabs.service';

import {
  fetchReiumbursementTabsDataSuccess,
  fetchReiumbursementTabsDataLoading,
  fetchReiumbursementTabsDataError,
  fetchAppealsTabDetailsDataSuccess,
  fetchAppealsTabDetailsDataLoading,
  fetchAppealsTabDetailsDataError,
  fetchReconsiderationTabDetailsDataSuccess,
  fetchReconsiderationTabDetailsDataLoading,
  fetchReconsiderationTabDetailsDataError,
  fetchDopFiltersDataSuccess,
  fetchNonPaymentTabDataSuccess,
  fetchNonPaymentTabDataError,
  fetchNonPaymentTabDataLoading,
  reimbursementPollingStarted,
  reimbursementPollingCompleted,
  reimbursementPollingError,
  reimbursementPollingReset

} from '@src/middleware/actions/Reimbursement/reiumbursementTabDataAction';
import { startJobPolling, resetPollingQueue } from '@src/utility/CommonBulkPoll';

export function* fetchReiumbursementTabsDataSaga(action: any) {
  resetPollingQueue();
  yield put(reimbursementPollingReset());
  const correlationId = `fetchReiumbursementTabsDataSaga-DOP-${Date.now()}`;
  try {
    yield put(fetchReiumbursementTabsDataLoading(true));
    if (action?.payload && action.payload.ClaimsBy === 'DOP') {
       const { Type, OverturnPass, ...filteredPayload } = action?.payload || {};
      const [initialResponse, paymentMetricResponse] = yield all([
        call(getReiumbursementTabsDataDopFilters, {
          ...filteredPayload
        }, action.highVolumeTinFlag),
        call(getReiumbursementTabData, { ...action?.payload, ClaimsBy: 'DOS' }, action.highVolumeTinFlag),
      ]);
      let transformedData;
      let tabMetricTranformedData;
      if (action.highVolumeTinFlag === true) {
        const jobId = initialResponse?.Data?.JobId;
        const isAccepted = initialResponse?.Data?.Status === "ACCEPTED"
        const paymentMetricResponseJobId = paymentMetricResponse?.Data?.JobId;
        const isPaymentMetricResponseAccepted = paymentMetricResponse?.Data?.Status === "ACCEPTED";

        if (jobId && isAccepted) {
          let fullPollingResponse: any = null;
          const pollingPromise = () => {
            return new Promise((resolve, reject) => {
              startJobPolling(
                jobId, // Pass jobId as parameter
                {
                  onInProgress: () => {},
                  onCompleted: (result) => {
                    resolve(result);
                  },
                  onFailed: (errorMessage) => {
                    reject(new Error(errorMessage));
                  },
                  onStatusUpdate: (response) => {
                    // Capture the full polling response
                    fullPollingResponse = response;
                  }
                },
                '/job-status/result',
                1000
              );
            });
          };

          const pollingResult = yield call(pollingPromise);
          transformedData = pollingResult || [];
        }

        if (paymentMetricResponseJobId && isPaymentMetricResponseAccepted) {
          let fullPollingResponse: any = null;
          const pollingPromise = () => {
            return new Promise((resolve, reject) => {
              startJobPolling(
                paymentMetricResponseJobId, // Pass jobId as parameter
                {
                  onInProgress: () => {},
                  onCompleted: (result) => {
                    resolve(result);
                  },
                  onFailed: (errorMessage) => {
                    reject(new Error(errorMessage));
                  },
                  onStatusUpdate: (response) => {
                    // Capture the full polling response
                    fullPollingResponse = response;
                  }
                },
                '/job-status/result',
                1000
              );
            });
          };

          const pollingResult = yield call(pollingPromise);
          tabMetricTranformedData = pollingResult || [];
        }
      }

      if (initialResponse || paymentMetricResponse) {
        yield put(fetchDopFiltersDataSuccess({
          dopFiltersData: transformedData ? transformedData : initialResponse?.Data,
          initialData: tabMetricTranformedData ? tabMetricTranformedData : paymentMetricResponse?.Data,
        }));
      }
    } else {
      if (action.highVolumeTinFlag === true) {
        yield put(reimbursementPollingStarted(correlationId));
      }

      const [initialResponse, paymentMetricResponse] = yield all([
        call(getReiumbursementTabData, { ...action?.payload, ClaimsBy: 'DOS' }, action.highVolumeTinFlag),
        call(getReiumbursementTabDataMetrics, { ...action?.payload, ClaimsBy: 'DOS' }, action.highVolumeTinFlag),
      ]);

       if (action.highVolumeTinFlag === true) {

        const jobId = initialResponse?.Data?.JobId;
        const isAccepted = initialResponse?.Data?.Status === "ACCEPTED"

        const reiembursementMetricsJobId = paymentMetricResponse?.Data?.JobId;
        const isReiembursementMetricsAccepted = paymentMetricResponse?.Data?.Status === "ACCEPTED"
        let reimbusementTabData;
        let reimbusementTabDataMetrics;
        if (jobId && isAccepted) {
          let fullPollingResponse: any = null;
          reimbusementTabData = () => {
            return new Promise((resolve, reject) => {
              startJobPolling(
                jobId, // Pass jobId as parameter
                {
                  onInProgress: () => {},
                  onCompleted: (result) => {
                    resolve(result);
                  },
                  onFailed: (errorMessage) => {
                    reject(new Error(errorMessage));
                  },
                  onStatusUpdate: (response) => {
                    // Capture the full polling response
                    fullPollingResponse = response;
                  }
                },
                '/job-status/result',
                1000
              );
            });
          };

        }
        if (reiembursementMetricsJobId && isReiembursementMetricsAccepted) {
          let fullPollingResponse: any = null;
          reimbusementTabDataMetrics = () => {
            return new Promise((resolve, reject) => {
              startJobPolling(
                reiembursementMetricsJobId,
                {
                  onInProgress: () => {},
                  onCompleted: (result) => {
                    resolve(result);
                  },
                  onFailed: (errorMessage) => {
                    reject(new Error(errorMessage));
                  },
                  onStatusUpdate: (response) => {
                    fullPollingResponse = response;
                  }
                },
                '/job-status/result',
                1000
              );
            });
          };
        }

        // Skip tab data polling for bulk flow (claims-overturn-metrics suppressed)
        //const reimbusementTabDataPollingResult = null;
        const reimbusementTabDataPollingResult = yield call(reimbusementTabData);
        const reimbusementTabDataMetricsPollingResult = yield call(reimbusementTabDataMetrics);

        const transformedData = reimbusementTabDataPollingResult || [];
        const tabMetricTranformedData = reimbusementTabDataMetricsPollingResult || [];

        yield put(
          fetchReiumbursementTabsDataSuccess({
            initialData: transformedData,
            claimsLobSummary: tabMetricTranformedData[0]?.All
          })
        );
        yield put(fetchReiumbursementTabsDataLoading(false));

       } else {
        if (initialResponse && paymentMetricResponse) {
          yield put(
            fetchReiumbursementTabsDataSuccess({
              initialData: initialResponse?.Data,
              claimsLobSummary: paymentMetricResponse?.Data?.[0]?.All,
              paymentMetricTinCount: paymentMetricResponse?.Data?.[0]?.TinCount,
            })
          );
        }
        yield put(fetchReiumbursementTabsDataLoading(false));
       }
    }

  } catch (error) {
    yield put(fetchReiumbursementTabsDataError(error));
    yield put(fetchReiumbursementTabsDataLoading(false));
    yield put(reimbursementPollingError(error));
  } finally {
    yield put(fetchReiumbursementTabsDataLoading(false));
    if (action.highVolumeTinFlag === true) {
     yield put(reimbursementPollingCompleted(correlationId));
    }
  }
}

export const fetchAppealsTabDetailsDataSaga = function* (action: any) {
  const correlationId = `fetchAppealsTabDetailsDataSaga-${Date.now()}`;
  if (action?.highVolumeTinFlag === true) {
    try {
      yield put(fetchAppealsTabDetailsDataLoading(true));
      yield put(reimbursementPollingStarted(correlationId));
      const initialResponse = yield call(getReiumbursementAppealsTabData,
        action?.payload,
        action.highVolumeTinFlag
      );
      const jobId = initialResponse?.Data?.JobId;
      const isAccepted = initialResponse?.Data?.Status === "ACCEPTED"

      if (jobId && isAccepted) {
        let fullPollingResponse: any = null;
        const pollingPromise = () => {
          return new Promise((resolve, reject) => {
            startJobPolling(
              jobId, // Pass jobId as parameter
              {
                onInProgress: () => {},
                onCompleted: (result) => {
                  resolve(result);
                },
                onFailed: (errorMessage) => {
                  reject(new Error(errorMessage));
                },
                onStatusUpdate: (response) => {
                  // Capture the full polling response
                  fullPollingResponse = response;
                }
              },
              '/job-status/result',
              1000
            );
          });
        };

        const pollingResult = yield call(pollingPromise);
        const transformedData = pollingResult || [];
        yield put(fetchAppealsTabDetailsDataSuccess(transformedData));
      } else {
        yield put(fetchAppealsTabDetailsDataLoading(false));
      }
    } catch (error) {
      yield put(fetchAppealsTabDetailsDataLoading(false));
      yield put(reimbursementPollingError(error));
    } finally {
      yield put(reimbursementPollingCompleted(correlationId));
      yield put(fetchAppealsTabDetailsDataLoading(false));
    }


  } else {
    try {
      yield put(fetchAppealsTabDetailsDataLoading(true));
      const initialResponse = yield call(
        getReiumbursementAppealsTabData,
        action?.payload,
        action.highVolumeTinFlag
      );
      if (initialResponse) {
        yield put(fetchAppealsTabDetailsDataSuccess(initialResponse?.Data));
      }

      yield put(fetchAppealsTabDetailsDataLoading(false));
    } catch (error) {
      yield put(fetchAppealsTabDetailsDataError(error));
      yield put(fetchAppealsTabDetailsDataLoading(false));
      yield put(reimbursementPollingError(error));
    }
  }
};

export const fetchReconsiderationTabDetailsDataSaga = function* (action: any) {
  if (action.highVolumeTinFlag === true) {
    const correlationId = `fetchReconsiderationTabDetailsDataSaga-${Date.now()}`;
    try {
      yield put(reimbursementPollingStarted(correlationId));
      yield put(fetchReconsiderationTabDetailsDataLoading(true));
      const initialResponse = yield call(
        getReiumbursementReconsiderationTabData,
        action?.payload,
        action.highVolumeTinFlag
      );

      const jobId = initialResponse?.Data?.JobId;
      const isAccepted = initialResponse?.Data?.Status === "ACCEPTED"

      if (jobId && isAccepted) {
        let fullPollingResponse: any = null;
        const pollingPromise = () => {
          return new Promise((resolve, reject) => {
            startJobPolling(
              jobId, // Pass jobId as parameter
              {
                onInProgress: () => {},
                onCompleted: (result) => {
                  resolve(result);
                },
                onFailed: (errorMessage) => {
                  reject(new Error(errorMessage));
                },
                onStatusUpdate: (response) => {
                  // Capture the full polling response
                  fullPollingResponse = response;
                }
              },
              '/job-status/result',
              1000
            );
          });
        };

        // Step 4: Wait for polling to complete
        const pollingResult = yield call(pollingPromise);

        const transformedData = pollingResult || [];
        yield put(fetchReconsiderationTabDetailsDataSuccess(transformedData));
        yield put(reimbursementPollingCompleted(correlationId));
      } else {
        yield put(fetchReconsiderationTabDetailsDataLoading(false));
      }
    } catch (error) {
      yield put(fetchReconsiderationTabDetailsDataError(error));
      yield put(fetchReconsiderationTabDetailsDataLoading(false));
      yield put(reimbursementPollingError(error));
      yield put(reimbursementPollingCompleted(correlationId));
    } finally {
      yield put(fetchReconsiderationTabDetailsDataLoading(false));
      if (yield cancelled()) {
        yield put(reimbursementPollingCompleted(correlationId));
      }
    }

  } else {
    yield put(fetchReconsiderationTabDetailsDataLoading(true));
    try {
      yield put(fetchReconsiderationTabDetailsDataLoading(true));
      // Assuming there's a service method similar to getReiumbursementAppealsTabData
      const initialResponse = yield call(
        getReiumbursementReconsiderationTabData,
        action?.payload,
        action.highVolumeTinFlag
      );
      if (initialResponse) {
        yield put(
          fetchReconsiderationTabDetailsDataSuccess(initialResponse?.Data)
        );
      }
      yield put(fetchReconsiderationTabDetailsDataLoading(false));
    } catch (error) {
      yield put(fetchReconsiderationTabDetailsDataError(error));
      yield put(fetchReconsiderationTabDetailsDataLoading(false));
    }
  }
};

export const fetchNonPaymentTabData = function* (action: any) {
  const correlationId = `fetchNonPaymentTabData-${Date.now()}`;
  if (action.highVolumeTinFlag === true) {
     try {
      yield put(reimbursementPollingStarted(correlationId));
      yield put(fetchNonPaymentTabDataLoading(true));
      const initialResponse = yield call(
        getReiumbursementNonPaymentTabData,
        action?.payload,
        action.highVolumeTinFlag
      );

      const jobId = initialResponse?.Data?.JobId;
      const isAccepted = initialResponse?.Data?.Status === "ACCEPTED"

      if (jobId && isAccepted) {
        let fullPollingResponse: any = null;
        const pollingPromise = () => {
          return new Promise((resolve, reject) => {
            startJobPolling(
              jobId, // Pass jobId as parameter
              {
                onInProgress: () => {},
                onCompleted: (result) => {
                  resolve(result);
                },
                onFailed: (errorMessage) => {
                  reject(new Error(errorMessage));
                },
                onStatusUpdate: (response) => {
                  // Capture the full polling response
                  fullPollingResponse = response;
                }
              },
              '/job-status/result',
              1000
            );
          });
        };

        // Step 4: Wait for polling to complete
        const pollingResult = yield call(pollingPromise);

        const transformedData = pollingResult || [];
        yield put(fetchNonPaymentTabDataSuccess(transformedData));

      } else {
        yield put(fetchNonPaymentTabDataLoading(false));
      }

    } catch (error) {
      yield put(fetchNonPaymentTabDataError(error));
      yield put(fetchNonPaymentTabDataLoading(false));
      yield put(reimbursementPollingError(error));
    } finally {
      yield put(reimbursementPollingCompleted(correlationId));
      yield put(fetchNonPaymentTabDataLoading(false));
    }
  } else {
    try {
      yield put(fetchNonPaymentTabDataLoading(true));
      const initialResponse = yield call(
        getReiumbursementNonPaymentTabData,
        action?.payload,
        action.highVolumeTinFlag
      );
      if (initialResponse) {
        yield put(fetchNonPaymentTabDataSuccess(initialResponse?.Data));
      }
      yield put(fetchNonPaymentTabDataLoading(false));
    } catch (error) {
      yield put(fetchNonPaymentTabDataError(error));
      yield put(fetchNonPaymentTabDataLoading(false));
    }
  }

};

export function* reiumbursementTabsSaga() {
  yield takeLatest(
    REIUMBURSEMENT_TABS_DATA_REQUEST,
    fetchReiumbursementTabsDataSaga
  );
  yield takeLatest(
    REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_REQUEST,
    fetchAppealsTabDetailsDataSaga
  );
  yield takeLatest(
    REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_REQUEST,
    fetchReconsiderationTabDetailsDataSaga
  );
  yield takeLatest(
    REIUMBURSEMENT_TABS_NONPAYMENT_REQUEST,
    fetchNonPaymentTabData
  );
}
